import { EAppTheme } from "./types";

export const APP_THEME_STORAGE_KEY = "app_theme_config";

export const DEFAULT_APP_THEME = EAppTheme.LIGHT;
